
export const checkoutPageTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] }
};

export const stepTransition = {
    initial: { opacity: 0, x: 50 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 },
    transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] }
};

export const cardFloat = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
};

export const formReveal = {
    initial: { opacity: 0, height: 0 },
    animate: { opacity: 1, height: 'auto' },
    transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] }
};

export const priceUpdate = {
    initial: { scale: 1.2, opacity: 0.5 },
    animate: { scale: 1, opacity: 1 },
    transition: { duration: 0.3, ease: [0.16, 1, 0.3, 1] }
};

export const successReveal = {
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    transition: {
        scale: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
        opacity: { duration: 0.4, ease: [0.16, 1, 0.3, 1] }
    }
};

export const shimmerAnimation = {
    animate: {
        backgroundPosition: ['200% 0', '-200% 0'],
        transition: {
            duration: 2,
            repeat: Infinity,
            ease: 'linear'
        }
    }
};